import 'ui-core/components/drop-block/js/drop-block.js';

const dropBlock = UX.dropBlock;

dropBlock.setFocus = function () {};

dropBlock.additionalOnShow = () => {
    const userAgent = navigator.userAgent.toLowerCase(),
        isSafari = userAgent.indexOf('safari') !== -1;

    if (dropBlock.$target && !isSafari) {
        !UX.dropBlock.isMobile && dropBlock.$target.attr('tabindex', '-1');
    }
};

dropBlock.additionalOnHide = () => {
    if (dropBlock.$target) {
        !UX.dropBlock.isMobile && dropBlock.$target.removeAttr('tabindex');
    }
};
